import { useEffect, useState } from "react";
import { ThumbsUp, Heart, PartyPopper, Lightbulb } from "lucide-react";
import api from "@/lib/api";

const TYPES = [
  { key: "thumbs_up", label: "Like", Icon: ThumbsUp },
  { key: "heart", label: "Love", Icon: Heart },
  { key: "celebrate", label: "Celebrate", Icon: PartyPopper },
  { key: "insightful", label: "Insightful", Icon: Lightbulb },
];

export const ReactionBar = ({ updateId, canReact = false }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/updates/${updateId}/reactions`).then(({ data }) => setData(data)).catch((e) => console.error("reactions load failed", e));
  }, [updateId]);

  const react = async (type) => {
    if (!canReact) return;
    try { const { data } = await api.post(`/updates/${updateId}/reactions`, { type }); setData(data); }
    catch (e) { console.error("reaction failed", e); }
  };

  if (!data) return null;

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="reaction-bar">
      {TYPES.map(({ key, label, Icon }) => {
        const active = data.mine === key;
        const count = data.counts?.[key] || 0;
        return (
          <button key={key} onClick={() => react(key)} disabled={!canReact}
            title={label}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${
              active ? "border-primary bg-primary/10 text-primary" : "bg-card text-muted-foreground"
            } ${canReact ? "hover:border-primary/50 hover:text-primary" : "cursor-default"}`}
            data-testid={`reaction-${key}`}>
            <Icon className="h-3.5 w-3.5" />
            {label}{count > 0 && <span className="tabular-nums">{count}</span>}
          </button>
        );
      })}
    </div>
  );
};
